export const MIN_MOBILE_SCREEN_WIDTH = 1320